export default __webpack_public_path__ + "static/media/category-left-arrow.575eda29.svg";